/**
 * Translate description: Table component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../../context/LanguageContext";
import AppContext from '../../../context/AppContext';

import Filter from '../../../components/filter/Filter';
import FilterSourceLang from '../../../components/filter/FilterSourceLang';
import DateFilter from '../../../components/filter/FilterDate';
import FilterUser from '../../../components/filter/FilterUser';
import FilterStore from '../../../components/filter/FilterStore';

import {
  ContentTable, ContentHeader, ContentHeaderItem, ContentBody,
  ContentBodyCheckbox, ContentBodyItem,
} from '../../../components/blocks/ContentTable';

import { Typography } from '@mui/joy'

import { ContentList, ContentListRow, ContentListItem } from '../../../components/blocks/ContentList';

import moment from 'moment/moment';

export default function Content() {
  const { t } = useLanguageContext();
  const { listItems } = useContext(AppContext);
  const { loading } = useContext(AppContext);

  return (
    <Fragment>
      <Filter fields={['orderid']} search_label="Search by CPA's order ID">
        <DateFilter />
        <FilterUser />
        <FilterStore />
        <FilterSourceLang />
      </Filter>

      <ContentTable>
        <ContentHeader>
          <ContentHeaderItem title={t('ID')} sortBy="id" width={50} />
          <ContentHeaderItem title={t('Store / User')} />
          <ContentHeaderItem title={t('Order ID')} />
          <ContentHeaderItem title={t('Amount')} width={100} />
          <ContentHeaderItem title={t('Reason')} />
          <ContentHeaderItem title={t('Created at')} sortBy="created_at" width={100} />
        </ContentHeader>

        <ContentBody colspan={7}>
          {(Array.isArray(listItems) && !loading && listItems?.length) ? (
            listItems.map((row) => (
              <tr key={row.id}>
                <ContentBodyCheckbox row={row} />
                <ContentBodyItem>{row.id}</ContentBodyItem>
                {/* <ContentBodyItem to={`/transaction/${row.id}`}>{row.store?.name} / {row.user?.name}</ContentBodyItem> */}
                <ContentBodyItem>{row.store?.name || t('no store')} / {row.user?.name || row.user?.login || t('no user')}</ContentBodyItem>
                <ContentBodyItem to={`/order/${row.order_id}`}>{row.order_id}</ContentBodyItem>
                <ContentBodyItem><Typography color={row.amount < 0 ? "danger" : "success"} level="body-xs">{row.amount}</Typography></ContentBodyItem>
                <ContentBodyItem>{row.reason}</ContentBodyItem>
                <ContentBodyItem>{moment(row.created_at).format('YYYY-MM-DD HH:mm:ss')}</ContentBodyItem>
              </tr>
            ))
          ) : null}
        </ContentBody>
      </ContentTable>

      <ContentList>
        {(Array.isArray(listItems) && !loading && listItems?.length) ? (
          listItems.map((row) => (
            <ContentListRow key={row.id} row={row} editLink={'transaction'} deleteLink={'transactions'}>
              <ContentListItem>{row.id}</ContentListItem>
            </ContentListRow>
          ))
        ) : null}
      </ContentList>

    </Fragment >
  );
}